 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about-page~banners-page~bulletin-page~calendar-page~contact-page~error~history-page~layout-default~l~0a38736c":"about-page~banners-page~bulletin-page~calendar-page~contact-page~error~history-page~layout-default~l~0a38736c","about-page~banners-page~bulletin-page~calendar-page~contact-page~history-page~layout-default~letter-~2cd050f6":"about-page~banners-page~bulletin-page~calendar-page~contact-page~history-page~layout-default~letter-~2cd050f6","about-page~banners-page~bulletin-page~calendar-page~contact-page~history-page~layout-default~ministr~88ecbcda":"about-page~banners-page~bulletin-page~calendar-page~contact-page~history-page~layout-default~ministr~88ecbcda","about-page":"about-page","banners-page~contact-page~history-page~layout-default":"banners-page~contact-page~history-page~layout-default","banners-page":"banners-page","contact-page":"contact-page","history-page":"history-page","layout-default":"layout-default","bulletin-page":"bulletin-page","calendar-page~starter-page":"calendar-page~starter-page","calendar-page":"calendar-page","starter-page":"starter-page","ministries-page~service-page":"ministries-page~service-page","ministries-page":"ministries-page","service-page":"service-page","letter-page":"letter-page","watch-page":"watch-page","zoom-page":"zoom-page","error":"error","layout-error":"layout-error"}[chunkId]||chunkId) + "." + {"about-page~banners-page~bulletin-page~calendar-page~contact-page~error~history-page~layout-default~l~0a38736c":"428f7f2f","about-page~banners-page~bulletin-page~calendar-page~contact-page~history-page~layout-default~letter-~2cd050f6":"27fe6346","about-page~banners-page~bulletin-page~calendar-page~contact-page~history-page~layout-default~ministr~88ecbcda":"815c4ea0","about-page":"14ac5b1e","banners-page~contact-page~history-page~layout-default":"69f9f6cc","banners-page":"df2a103d","contact-page":"f56e25f8","history-page":"4c948ebb","layout-default":"30817fdb","bulletin-page":"d438b422","calendar-page~starter-page":"138fbd57","calendar-page":"3dc5a06d","starter-page":"f94518be","ministries-page~service-page":"c17918d0","ministries-page":"abb02fe6","service-page":"278ed4fa","letter-page":"08964b07","watch-page":"1dce2856","zoom-page":"b22fc1f7","error":"4e3c7cf3","layout-error":"5981bebe"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"about-page~banners-page~bulletin-page~calendar-page~contact-page~error~history-page~layout-default~l~0a38736c":1,"about-page~banners-page~bulletin-page~calendar-page~contact-page~history-page~layout-default~letter-~2cd050f6":1,"about-page~banners-page~bulletin-page~calendar-page~contact-page~history-page~layout-default~ministr~88ecbcda":1,"about-page":1,"banners-page~contact-page~history-page~layout-default":1,"banners-page":1,"contact-page":1,"history-page":1,"layout-default":1,"bulletin-page":1,"calendar-page~starter-page":1,"calendar-page":1,"starter-page":1,"ministries-page~service-page":1,"ministries-page":1,"letter-page":1,"watch-page":1,"zoom-page":1,"error":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about-page~banners-page~bulletin-page~calendar-page~contact-page~error~history-page~layout-default~l~0a38736c":"about-page~banners-page~bulletin-page~calendar-page~contact-page~error~history-page~layout-default~l~0a38736c","about-page~banners-page~bulletin-page~calendar-page~contact-page~history-page~layout-default~letter-~2cd050f6":"about-page~banners-page~bulletin-page~calendar-page~contact-page~history-page~layout-default~letter-~2cd050f6","about-page~banners-page~bulletin-page~calendar-page~contact-page~history-page~layout-default~ministr~88ecbcda":"about-page~banners-page~bulletin-page~calendar-page~contact-page~history-page~layout-default~ministr~88ecbcda","about-page":"about-page","banners-page~contact-page~history-page~layout-default":"banners-page~contact-page~history-page~layout-default","banners-page":"banners-page","contact-page":"contact-page","history-page":"history-page","layout-default":"layout-default","bulletin-page":"bulletin-page","calendar-page~starter-page":"calendar-page~starter-page","calendar-page":"calendar-page","starter-page":"starter-page","ministries-page~service-page":"ministries-page~service-page","ministries-page":"ministries-page","service-page":"service-page","letter-page":"letter-page","watch-page":"watch-page","zoom-page":"zoom-page","error":"error","layout-error":"layout-error"}[chunkId]||chunkId) + "." + {"about-page~banners-page~bulletin-page~calendar-page~contact-page~error~history-page~layout-default~l~0a38736c":"e449fc26","about-page~banners-page~bulletin-page~calendar-page~contact-page~history-page~layout-default~letter-~2cd050f6":"7936880e","about-page~banners-page~bulletin-page~calendar-page~contact-page~history-page~layout-default~ministr~88ecbcda":"07f67d8f","about-page":"50ee6631","banners-page~contact-page~history-page~layout-default":"8abdd2ae","banners-page":"13fe81e8","contact-page":"6430e621","history-page":"7f488c4f","layout-default":"e46127c2","bulletin-page":"40d7540a","calendar-page~starter-page":"4eac5ef3","calendar-page":"72a9c1a6","starter-page":"edc9f1ae","ministries-page~service-page":"861ef8b4","ministries-page":"f1d8454a","service-page":"31d6cfe0","letter-page":"dbf88e8a","watch-page":"a9a29707","zoom-page":"077a8ff1","error":"1cdd82ce","layout-error":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
